/* istanbul ignore file */
import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty, isNil } from 'lodash';
import SahamTabs from 'components/SahamTabs';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import ClaimRecap from 'containers/LawyerRecapPage/LawyerRecap';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import CourtManagerRecapAdd from 'containers/CourtManagerLegalProceedings/JudgementAdd';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { StyledSahamTabs } from 'components/SahamTabs/styled-components';
import { Container } from 'containers/CourtManagerLegalProceedings/styled-components';
import {
  getJomVehicles,
  getJomVictims,
  getJudgementAddDocuments,
  getLabelByFFlip,
  getSteps,
  resolveJudgementAddDocs,
  showExpertReport,
  ShowExpertExpertise,
} from 'containers/LawyerLegalProceedingsPage/utils';
import CourtManagerExpertReport from 'containers/CourtManagerLegalProceedings/ExpertReport';
import CourtManagerExpertReportAppeal from 'containers/CourtManagerLegalProceedings/ExpertReportAppeal/index';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { JUDGEMENT, LISTINGS } from 'containers/data-structure';
import { StyledSahamAppelTabs } from 'components/SahamTabs/styled-components';
import JudgementOnMeritsManagerRecap from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/JudgementOnMeritsManagerRecap';
import JudgementOnMeritsManagerRecapAppeal from 'containers/CourtManagerLegalProceedings/AppealOnMerits/JudgementOnMeritsManagerRecap';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';

import LegalProceedingTabs from 'components/LegalProceedingTabs';
import ToggleTabs from 'components/ToggleTabs';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import CourtManagerRecapAddAppeal from 'containers/CourtManagerLegalProceedings/AppealAdd/index';
import CivilProceedingRecap from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import * as util from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import Contestation from 'containers/LawyerLegalProceedingsPage/Contestation';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { LABEL_INSTANCES } from 'containers/CourtManagerLegalProceedings/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  filterVictim,
  proceedingTabs,
  filterVehicle,
} from 'containers/CourtManagerLegalProceedings/utils';
import ExpertReport from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport';
import { renderSearchQuery } from 'containers/ExpertAssignedMissionShow/utils';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { useHistory } from 'react-router';
import AlertInformationDialog from 'containers/CourtManagerLegalProceedings/AlertInformationDialog';
import { getBeneficiaries } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import { ClaimRecapType } from 'typings/claimTypes';
import { Claim } from 'containers/PreOpeningPage/typings';

export interface ManagerLegalProceedingsProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  onPressFeeNote: () => void;
  requestUpdatedCivilProceeding: Function;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  requestGetDahirAmountCorpo: Function;
  dahirAmountsCorpo: any;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  judgementAddAppeal: any;
  requestValidatedCivilProceeding: Function;
  requestMakeJudgementAddDocumentDecision: Function;
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestCreateVehicle?: Function;
  requestAddVictims: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVehicles: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  currentJudiciaryProcess: any;
  expertExpertise?: any;
  requestMakeDecisionMissionExpertise: Function;
  loaders: any;
  onPressAssignment?: () => void;
  requestCreateJudgementAdd: Function;
  requestCreateMultipleJudgementAdd: Function;
  requestCreateExpertiseRaport: Function;
  currentIndexTabManager: any;
  currentInstanceTabIndexManager: any;
  currentJudiciaryProccessId: any;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  currentGlobalTabManagerIndex: any;
  isButtonRedirect: boolean;
  setIsButtonRedirect: Function;
  setOpenFeeNoteDialog: Function;
  requestGetReportsPolicy: Function;
  requestGetClaimCivilParty: Function;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
}

export const ManagerLegalProceedingsPage: React.FC<ManagerLegalProceedingsProps> = (
  props,
): JSX.Element => {
  const history = useHistory();
  const [showAlertInformation, setShowAlertInformation] = useState(false);
  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber');

  const judgementOnMeritsMultiple = get(
    props.judgementOnMeritsMultiple,
    'judgementOnMerits',
    [],
  ).filter((jom: any) => !jom.isFirst);

  const appealOnMeritsMultiple = get(
    props.appealOnMeritsMultiple,
    'judgementOnMerits',
    [],
  ).filter((jom: any) => !jom.isFirst);

  const firstJom =
    get(props, 'judgementOnMeritsMultiple.judgementOnMerits', []).find(
      (jom: any) => jom.isFirst,
    ) || {};
  const firstJomAppeal =
    get(props, 'appealOnMeritsMultiple.judgementOnMerits', []).find(
      (jom: any) => jom.isFirst,
    ) || {};
  const currentJomMultiple = isEmpty(firstJomAppeal)
    ? firstJom
    : firstJomAppeal;

  const [jomLabels, setJomLabels] = React.useState([]);
  const [associatedVictims, setAssociatedVictims] = React.useState([]);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings, props.currentInstanceTabIndexManager]);

  const getJomDeceasedVictimsAppeal = (judgementAdd: any, jomId: number) => {
    const beneficiaries = getBeneficiaries(judgementAdd, jomId);
    return beneficiaries.map((el: any) => get(el, 'beneficiary.victim.id'));
  };
  const tabs = {
    FIRST_INSTANCE: {
      id: 0,
      title: translate(messages.firstInstance, props),
      feature: featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL),
    },
    APPEAL: {
      id: 1,
      title: translate(messages.appeal, props),
      feature: featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL),
    },
  } as any;

  const getJomDeceasedVictims = (judgementAdd: any, jomId: number) => {
    const beneficiaries = getBeneficiaries(judgementAdd, jomId);
    return beneficiaries.map((el: any) => get(el, 'beneficiary.victim.id'));
  };
  useEffect(() => {
    if (props.judiciaryProcessId) {
      props.getLegalProceedingsSteps(claimId, props.judiciaryProcessId);
      props.requestClaimRecap(claimId);
      if (featureService.hasFeature(FEATURES.GET_LEGAL_PROCEEDING)) {
        props.requestGetJudgements(
          claimId,
          Number(props.currentTabInstance) ===
            get(labelsInstance[LABEL_INSTANCES.APPEAL], 'id')
            ? PROCEDURE_TYPES.APPEAL
            : PROCEDURE_TYPES.FIRST_INSTANCE,
          props.judiciaryProcessId,
        );
      } else {
        if (
          Number(props.currentTabInstance) ===
          get(labelsInstance[LABEL_INSTANCES.APPEAL], 'id')
        ) {
          props.requestGetJudgementAdd(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementAddAppeal(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetExpertiseRaport(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetExpertiseReportAppeal(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementOnMerits(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementOnMeritsAppeal(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetAppealOnMeritsMultiple(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );
        } else if (
          Number(props.currentTabInstance) ===
          get(labelsInstance[LABEL_INSTANCES.FIRST_INSTANCE], 'id')
        ) {
          props.requestGetJudgementAdd(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
          props.requestGetExpertiseRaport(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
          props.requestGetJudgementOnMerits(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
          props.requestGetJudgementOnMeritsMultiple(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
        }
      }

      featureService.hasFeature(FEATURES.EVOLUTION_P3)
        ? props.requestFeeNotesByClaimNumb(claimNumber, [], true, claimId)
        : props.requestFeeNotesByClaimNumb(claimNumber, [], null, claimId);
    }
  }, [
    props.judiciaryProcessId,
    claimId,
    claimNumber,
    props.currentJudiciaryProccessId,
    props.currentTabInstance,
  ]);
  const [jomAppealLabels, setJomAppealLabels] = useState([]);

  const [judgementAddClone, setjudgementAddClone] = React.useState<
    IJudgementAdd | { status: string }
  >({} as IJudgementAdd | { status: string });

  useDeepCompareEffect(() => {
    setjudgementAddClone(cloneDeep(props.judgementAdd));
  }, [props.judgementAdd, props.currentIndexTabManager]);
  const labelsToDisplay = [
    messages.courtManagerRecapTitle,
    ...getLabelByFFlip(props.currentSteps, true),
  ].map(label => translate(label, props));
  const isCivilProceedingCommercial =
    get(
      props.civilProceeding.find(
        (element: { id: number }) => element.id === props.judiciaryProcessId,
      ),
      'procedureNatureId',
    ) === 2 ||
    get(
      props.civilProceeding.find(
        (element: { id: number }) => element.id === props.judiciaryProcessId,
      ),
      'procedureNatureId',
    ) === 1
      ? true
      : false;

  const proceedingLabels = (type: string, judgementAdd: any) => {
    return isCivilProceedingCommercial
      ? type === PROCEDURE_TYPES.FIRST_INSTANCE
        ? [
            ...[
              messages.requestCivil,
              ...getSteps(
                type,
                showExpertReport(judgementAdd),
                ShowExpertExpertise(
                  props.expertExpertise,
                  props.judiciaryProcessId,
                  1,
                ),
              ),
            ].map(label =>
              translate(label, props, {
                jomId: !isNil(
                  get(
                    props.judgementOnMerits,
                    'judgementOnMerits.jom.judgementDate',
                    get(
                      judgementOnMeritsMultiple,
                      '[0].jom.judgementDate',
                      null,
                    ),
                  ),
                )
                  ? props.intl.formatDate(
                      get(
                        props.judgementOnMerits,
                        'judgementOnMerits.jom.judgementDate',
                        get(judgementOnMeritsMultiple, '[0].jom.judgementDate'),
                      ),
                      {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      },
                    )
                  : '',
              }),
            ),
            ...judgementOnMeritsMultiple
              .sort(
                (a: any, b: any) =>
                  new Date(get(a, 'createdAt')).valueOf() -
                  new Date(get(b, 'createdAt')).valueOf(),
              )
              .map((el: any, index: number) =>
                translate(messages.judgementOnMeritsLabelTitle, props, {
                  jomId: !isNil(get(el, 'jom.judgementDate', null))
                    ? props.intl.formatDate(get(el, 'jom.judgementDate'), {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      })
                    : '',
                }),
              ),
            ...jomLabels.map((label: string, index: number) =>
              translate(label, props, { jomId: index + 1 }),
            ),
          ]
        : [
            ...getSteps(
              type,
              showExpertReport(judgementAdd),
              ShowExpertExpertise(
                props.expertExpertise,
                props.judiciaryProcessId,
                2,
              ),
            ).map(label =>
              translate(label, props, {
                jomId:
                  !isEmpty(currentJomMultiple) &&
                  !isNil(get(currentJomMultiple, 'jom.judgementDate', null)) &&
                  get(currentJomMultiple, 'procedureType') ===
                    PROCEDURE_TYPES.APPEAL
                    ? props.intl.formatDate(
                        get(currentJomMultiple, 'jom.judgementDate'),
                        {
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        },
                      )
                    : '',
              }),
            ),
            ...appealOnMeritsMultiple
              .sort(
                (a: any, b: any) =>
                  new Date(get(a, 'createdAt')).valueOf() -
                  new Date(get(b, 'createdAt')).valueOf(),
              )
              .map((el: any, index: number) =>
                translate(messages.appealOnMeritsLabelTitle, props, {
                  appealId: !isNil(get(el, 'jom.judgementDate', null))
                    ? props.intl.formatDate(get(el, 'jom.judgementDate'), {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      })
                    : '',
                }),
              ),
            ...jomAppealLabels.map((label: string, index: number) =>
              translate(label, props, { appealId: index + 1 }),
            ),
          ]
      : type === PROCEDURE_TYPES.FIRST_INSTANCE
      ? [
          ...getSteps(
            type,
            showExpertReport(judgementAdd),
            ShowExpertExpertise(
              props.expertExpertise,
              props.judiciaryProcessId,
              1,
            ),
          ).map(label =>
            translate(label, props, {
              jomId: !isNil(
                get(
                  props.judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  get(judgementOnMeritsMultiple, '[0].jom.judgementDate', null),
                ),
              )
                ? props.intl.formatDate(
                    get(
                      props.judgementOnMerits,
                      'judgementOnMerits.jom.judgementDate',
                      get(judgementOnMeritsMultiple, '[0].jom.judgementDate'),
                    ),
                    {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    },
                  )
                : '',
            }),
          ),
          ...judgementOnMeritsMultiple
            .sort(
              (a: any, b: any) =>
                new Date(get(a, 'createdAt')).valueOf() -
                new Date(get(b, 'createdAt')).valueOf(),
            )
            .map((el: any, index: number) =>
              translate(messages.judgementOnMeritsLabelTitle, props, {
                jomId: !isNil(get(el, 'jom.judgementDate', null))
                  ? props.intl.formatDate(get(el, 'jom.judgementDate'), {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    })
                  : '',
              }),
            ),
          ...jomLabels.map((label: string, index: number) =>
            translate(label, props, { jomId: index + 1 }),
          ),
        ]
      : [
          ...getSteps(
            type,
            showExpertReport(judgementAdd),
            ShowExpertExpertise(
              props.expertExpertise,
              props.judiciaryProcessId,
              2,
            ),
          ).map(label =>
            translate(label, props, {
              jomId:
                !isEmpty(currentJomMultiple) &&
                !isNil(get(currentJomMultiple, 'jom.judgementDate', null)) &&
                get(currentJomMultiple, 'procedureType') ===
                  PROCEDURE_TYPES.APPEAL
                  ? props.intl.formatDate(
                      get(currentJomMultiple, 'jom.judgementDate'),
                      {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      },
                    )
                  : '',
            }),
          ),
          ...appealOnMeritsMultiple
            .sort(
              (a: any, b: any) =>
                new Date(get(a, 'createdAt')).valueOf() -
                new Date(get(b, 'createdAt')).valueOf(),
            )
            .map((el: any, index: number) =>
              translate(messages.appealOnMeritsLabelTitle, props, {
                appealId: !isNil(get(el, 'jom.judgementDate', null))
                  ? props.intl.formatDate(get(el, 'jom.judgementDate'), {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    })
                  : '',
              }),
            ),
          ...jomAppealLabels.map((label: string, index: number) =>
            translate(label, props, { appealId: index + 1 }),
          ),
        ];
  };
  useDeepCompareEffect(() => {
    props.resetSearchClaimsStore();
    if (!isEmpty(props.claimRecap)) {
      const searchQuery = renderSearchQuery(props.claimRecap);
      props.requestSearchClaims(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap]);
  useDeepCompareEffect(() => {
    if (!isEmpty(props.judgementAdd)) {
      props.requestGetDahirAmountCorpo(claimId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementAdd, props.currentIndexTabManager]);

  let labelsInstance = { ...tabs };

  if (
    props.judgementOnMerits['judgementOnMerits'] &&
    props.judgementOnMerits['judgementOnMerits'].jom &&
    props.judgementOnMerits['judgementOnMerits'].jom.jmc
  ) {
    const contestationTypeNumber =
      props.judgementOnMerits['judgementOnMerits'].jom.jmc.type;
    const contestationTypes = props.listings.judgementOnMeritsContestationTypes;
    const contestationType =
      contestationTypes.find(type => type.id === contestationTypeNumber) || {};
    labelsInstance = {
      ...tabs,
      ...{
        CONTESTATION: {
          id: 3,
          title: get(contestationType, 'title', ''),
          feature: featureService.hasFeature(
            FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION,
          ),
        },
      },
    };
  }
  const procedureNatureId = get(
    props.civilProceeding.find(
      (element: { id: number }) => element.id === props.judiciaryProcessId,
    ),
    'procedureNatureId',
  );
  const isCivilProceeding =
    procedureNatureId === 2 || procedureNatureId === 1 ? true : false;

  const judgementAddDocuments = useMemo(
    () =>
      getJudgementAddDocuments(
        get(props, 'judgementAdd.judgementAddDocuments', []),
      ),
    [get(props, 'judgementAdd.judgementAddDocuments', [])],
  );
  const { currentTabIndex, labels = [] } = {
    currentTabIndex:
      props.currentTabInstance ||
      proceedingTabs(labelsInstance)?.currentTabIndex,
    labels: proceedingTabs(labelsInstance)?.labels,
  };
  const [currentActiveTab, setCurrentActiveTab] = useState(currentTabIndex);

  return (
    <Container>
      <StyledSahamTabs>
        {featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL) ? (
          <LegalProceedingTabs
            currentTabIndex={currentActiveTab}
            labels={labels}
            setCurrentInstanceTab={props.setCurrentInstanceTab}
            onPressFeeNote={props.onPressFeeNote}
            onPressAssignment={props.onPressAssignment}
          >
            <StyledSahamAppelTabs>
              <ToggleTabs
                currentTabIndex={props.currentIndexTabManager || 0}
                labels={proceedingLabels(
                  PROCEDURE_TYPES.FIRST_INSTANCE,
                  props.judgementAdd,
                )}
              >
                {isCivilProceedingCommercial &&
                  !isEmpty(props.civilProceeding) && (
                    <CivilProceedingRecap
                      listings={props.listings}
                      judiciaryProcessId={props.judiciaryProcessId}
                      civilProceeding={props.civilProceeding}
                      claimRecap={props.claimRecap}
                      corporealLawyers={props.corporealLawyers}
                      isManager={false}
                      validateUpdateRequest={
                        props.requestUpdatedCivilProceeding
                      }
                      lossDate={get(props.sagisClaim, 'lossDate', '')}
                      requestCorporealLawyers={props.requestCorporealLawyers}
                      requestValidatedCivilProceeding={
                        props.requestValidatedCivilProceeding
                      }
                      policyInfo={props.policyInfo}
                      requestSagisClaimInfo={props.requestSagisClaimInfo}
                      sagisClaim={props.sagisClaim}
                      handleOpenUpdateForm={() => {}}
                      judgementAdd={props.judgementAdd}
                      judgementOnMerits={props.judgementOnMerits}
                      sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                      sagisOpposingParties={extractOpposingParties(
                        get(props.sagisClaim, 'offeredRisks', []),
                      )}
                      isConsultation={true}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  )}
                <CourtManagerRecapAdd
                  listings={props.listings}
                  judgementAdd={props.judgementAdd}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  requestMakeJudgementAddDecision={
                    props.requestMakeJudgementAddDecision
                  }
                  feeNotes={props.feeNotes}
                  victims={get(props.claimRecap, 'victims', [])}
                  vehicules={filterVehicle(
                    get(props.claimRecap, 'vehicules', []),
                  )}
                  policyInfo={props.policyInfo}
                  claim={get(props.claimRecap, 'claim', {})}
                  isCivilProceeding={isCivilProceeding}
                  stakeholders={stakeholders}
                  assignedLawyer={get(
                    props.claimRecap,
                    'claim.assignment[0].assignedLawyer',
                  )}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  judiciaryProcessId={props.judiciaryProcessId}
                  isManager
                  requestMakeJudgementAddDocumentDecision={
                    props.requestMakeJudgementAddDocumentDecision
                  }
                  currentJudiciaryProcess={props.currentJudiciaryProcess}
                  loaders={props.loaders}
                  requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                  lossDate={get(props.claimRecap, 'claim.lossDate', null)}
                  requestGetJudgementAdd={props.requestGetJudgementAdd}
                  requestCreateMultipleJudgementAdd={
                    props.requestCreateMultipleJudgementAdd
                  }
                  expertReport={props.expertiseReport}
                  judgementOnMerits={props.judgementOnMeritsMultiple}
                  currentIndexTabManager={props.currentIndexTabManager}
                  documentId={props.documentId}
                  requestAddSupportDocument={props.requestAddSupportDocument}
                  requestCivilPartySupportDocument={
                    props.requestCivilPartySupportDocument
                  }
                  setDocumentId={props.setDocumentId}
                  sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisClaim, 'offeredRisks', []),
                  )}
                  setIsButtonRedirect={props.setIsButtonRedirect}
                  setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                  isConsultation
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  requestGetClaimCivilParty={() => {}}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
                {showExpertReport(props.judgementAdd) && (
                  <CourtManagerExpertReport
                    judgementAddDocuments={judgementAddDocuments}
                    listings={props.listings}
                    claimId={claimId}
                    claimNumber={claimNumber}
                    requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                    expertiseReport={props.expertiseReport}
                    requestValidateExpertReport={
                      props.requestValidateExpertReport
                    }
                    lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    claim={
                      (get(props.claimRecap, 'claim', {}) as unknown) as Claim
                    }
                    victims={get(props.claimRecap, 'victims', [])}
                    judiciaryProcessId={props.judiciaryProcessId}
                    policyInfo={props.policyInfo}
                    isManager
                    documentId={props.documentId}
                    setDocumentId={props.setDocumentId}
                    requestCreateExpertiseRaport={
                      props.requestCreateExpertiseRaport
                    }
                    currentIndexTabManager={props.currentIndexTabManager}
                    requestAddExpertiseSupportDocument={
                      props.requestAddExpertiseSupportDocument
                    }
                    hasJom={!isEmpty(props.judgementOnMeritsMultiple)}
                    sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                    sagisOpposingParties={extractOpposingParties(
                      get(props.sagisClaim, 'offeredRisks', []),
                    )}
                    isConsultation
                    imagineDocuments={[]}
                    dahirAmount={props.dahirAmount}
                    expertiseRaportFirstInstance={props.expertiseRaportAppeal}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}
                {ShowExpertExpertise(
                  props.expertExpertise,
                  props.judiciaryProcessId,
                  1,
                ) && (
                  <ExpertReport
                    expertisesVictim={
                      !isEmpty(props.expertExpertise) &&
                      props.expertExpertise.filter(
                        (el: any) =>
                          el?.mission?.judiciaryProcessId ===
                            props.judiciaryProcessId && el?.mission?.step === 1,
                      )
                    }
                    requestMakeDecisionMissionExpertise={
                      props.requestMakeDecisionMissionExpertise
                        ? props.requestMakeDecisionMissionExpertise
                        : () => {}
                    }
                    claimId={props.match.params.claimId}
                    isLawyer={true}
                    feeNotes={props.feeNotes}
                    claimNumber={claimNumber}
                    riskKey={get(
                      get(props.sagisClaim, 'offeredRisks', []).find(
                        (element: { riskName: string }) =>
                          element.riskName === rcCoporeal,
                      ),
                      'riskId',
                    )}
                    setOpenFeeNoteDialog={() => {}}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}
                {!isEmpty(props.judgementOnMerits) && (
                  <JudgementOnMeritsManagerRecap
                    listings={props.listings}
                    claimId={claimId}
                    claimNumber={claimNumber}
                    expertiseReport={props.expertiseReport}
                    civilProceeding={props.civilProceeding}
                    victims={filterVictim(get(props.claimRecap, 'victims', []))}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    documentId={props.documentId}
                    requestValidateJudgementOnMerits={
                      props.requestValidateJudgementOnMerits
                    }
                    judgementAdd={props.judgementAdd}
                    lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                    setDocumentId={props.setDocumentId}
                    requestGetJudgementOnMerits={
                      props.requestGetJudgementOnMerits
                    }
                    judgementOnMerits={props.judgementOnMerits}
                    judgementAddDocuments={get(
                      judgementAddClone,
                      'judgementAddDocuments',
                      [],
                    )}
                    dahirAmount={props.dahirAmount}
                    policyInfo={props.policyInfo}
                    judgementAddClone={judgementAddClone}
                    claim={get(props.claimRecap, 'claim', [])}
                    judiciaryProcessId={props.judiciaryProcessId}
                    dahirAmountsCorpo={props.dahirAmountsCorpo}
                    requestCreateJudgementOnMeritsContestation={
                      props.requestCreateJudgementOnMeritsContestation
                    }
                    isManager={false}
                    vehicules={filterVehicle(
                      get(props.claimRecap, 'vehicules', []),
                    )}
                    isCivilProceeding={isCivilProceedingCommercial}
                    setJomLabels={setJomLabels}
                    jomAssociatedVictims={associatedVictims}
                    setJomAssociatedVictims={setAssociatedVictims}
                    jomVictims={getJomVictims([
                      get(props.judgementOnMerits, 'judgementOnMerits'),
                      ...judgementOnMeritsMultiple,
                    ])}
                    jomVehicles={getJomVehicles([
                      get(props.judgementOnMerits, 'judgementOnMerits'),
                      ...judgementOnMeritsMultiple,
                    ])}
                    setJomAppealLabels={setJomAppealLabels}
                    setCurrentInstanceTab={props.setCurrentInstanceTab}
                    setCurrentActiveTab={setCurrentActiveTab}
                    setCurrentJom={() => {}}
                    isAssignedLawyer={false}
                    requestAddJudgementOnMeritsSupportDocument={
                      props.requestAddJudgementOnMeritsSupportDocument
                    }
                    sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                    sagisOpposingParties={extractOpposingParties(
                      get(props.sagisClaim, 'offeredRisks', []),
                    )}
                    jomDeceasedVictims={getJomDeceasedVictims(
                      judgementAddClone,
                      get(props.judgementOnMerits, 'judgementOnMerits.jom.id'),
                    )}
                    currentIndexTabManager={props.currentIndexTabManager}
                    judgementAddAppeal={props.judgementAddAppeal}
                    requestGetDahirAmount={props.requestGetDahirAmount}
                    currentInstanceTabIndexManager={
                      props.currentInstanceTabIndexManager
                    }
                    currentGlobalTabManagerIndex={
                      props.currentGlobalTabManagerIndex
                    }
                    currentJudiciaryProccessId={
                      props.currentJudiciaryProccessId
                    }
                    setIsButtonRedirect={props.setIsButtonRedirect}
                    setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                    isConsultation
                    imagineDocuments={[]}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}
                {judgementOnMeritsMultiple
                  .sort(
                    (a: any, b: any) =>
                      new Date(get(a, 'createdAt')).valueOf() -
                      new Date(get(b, 'createdAt')).valueOf(),
                  )
                  .map((el: any) => (
                    <JudgementOnMeritsManagerRecap
                      listings={props.listings}
                      claimId={claimId}
                      claimNumber={claimNumber}
                      expertiseReport={props.expertiseReport}
                      civilProceeding={props.civilProceeding}
                      victims={filterVictim(
                        get(props.claimRecap, 'victims', []),
                      )}
                      uploadDocument={props.uploadDocument}
                      uploadedDocument={props.uploadedDocument}
                      resetUploadedDocument={props.resetUploadedDocument}
                      documentId={props.documentId}
                      requestValidateJudgementOnMerits={
                        props.requestValidateJudgementOnMerits
                      }
                      judgementAdd={props.judgementAdd}
                      lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                      setDocumentId={props.setDocumentId}
                      requestGetJudgementOnMerits={
                        props.requestGetJudgementOnMerits
                      }
                      judgementOnMerits={
                        {
                          judgementOnMerits: { ...el },
                          beneficiaries: [
                            ...get(
                              props.judgementOnMeritsMultiple,
                              'beneficiaries',
                              [],
                            ),
                          ],
                        } as any
                      }
                      judgementAddDocuments={resolveJudgementAddDocs(
                        get(judgementAddClone, 'judgementAddDocuments', []),
                        [get(props.judgementOnMerits, 'judgementOnMerits')],
                      )}
                      dahirAmount={props.dahirAmount}
                      policyInfo={props.policyInfo}
                      judgementAddClone={judgementAddClone}
                      claim={get(props.claimRecap, 'claim', [])}
                      judiciaryProcessId={props.judiciaryProcessId}
                      dahirAmountsCorpo={props.dahirAmountsCorpo}
                      requestCreateJudgementOnMeritsContestation={
                        props.requestCreateJudgementOnMeritsContestation
                      }
                      isManager={false}
                      vehicules={filterVehicle(
                        get(props.claimRecap, 'vehicules', []),
                      )}
                      isCivilProceeding={isCivilProceedingCommercial}
                      setJomLabels={setJomLabels}
                      jomAssociatedVictims={associatedVictims}
                      setJomAssociatedVictims={setAssociatedVictims}
                      isMultiple
                      jomDeceasedVictims={getJomDeceasedVictims(
                        judgementAddClone,
                        get(el, 'jom.id'),
                      )}
                      jomVictims={getJomVictims([
                        get(props.judgementOnMerits, 'judgementOnMerits'),
                        ...judgementOnMeritsMultiple,
                      ])}
                      jomVehicles={getJomVehicles([
                        get(props.judgementOnMerits, 'judgementOnMerits'),
                        ...judgementOnMeritsMultiple,
                      ])}
                      setJomAppealLabels={setJomAppealLabels}
                      setCurrentInstanceTab={props.setCurrentInstanceTab}
                      setCurrentActiveTab={setCurrentActiveTab}
                      setCurrentJom={() => {}}
                      isAssignedLawyer={false}
                      requestAddJudgementOnMeritsSupportDocument={
                        props.requestAddJudgementOnMeritsSupportDocument
                      }
                      sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                      sagisOpposingParties={extractOpposingParties(
                        get(props.sagisClaim, 'offeredRisks', []),
                      )}
                      currentIndexTabManager={props.currentIndexTabManager}
                      judgementAddAppeal={props.judgementAddAppeal}
                      requestGetDahirAmount={props.requestGetDahirAmount}
                      currentInstanceTabIndexManager={
                        props.currentInstanceTabIndexManager
                      }
                      currentGlobalTabManagerIndex={
                        props.currentGlobalTabManagerIndex
                      }
                      currentJudiciaryProccessId={
                        props.currentJudiciaryProccessId
                      }
                      setIsButtonRedirect={props.setIsButtonRedirect}
                      setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                      isConsultation
                      imagineDocuments={[]}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  ))}
              </ToggleTabs>
            </StyledSahamAppelTabs>

            <StyledSahamAppelTabs>
              <ToggleTabs
                currentTabIndex={props.currentIndexTabManager || 0}
                labels={proceedingLabels(
                  PROCEDURE_TYPES.APPEAL,
                  props.judgementAdd,
                )}
              >
                <CourtManagerRecapAddAppeal
                  listings={props.listings}
                  judgementAdd={props.judgementAdd}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  requestMakeJudgementAddDecision={
                    props.requestMakeJudgementAddDecision
                  }
                  claim={get(props.claimRecap, 'claim', [])}
                  victims={filterVictim(get(props.claimRecap, 'victims', []))}
                  vehicules={filterVehicle(
                    get(props.claimRecap, 'vehicules', []),
                  )}
                  policyInfo={props.policyInfo}
                  stakeholders={stakeholders}
                  assignedLawyer={get(
                    props.claimRecap,
                    'claim.assignment[0].assignedLawyer',
                  )}
                  requestGetJudgementAdd={props.requestGetJudgementAdd}
                  judiciaryProcessId={props.judiciaryProcessId}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  requestMakeJudgementAddDocumentDecision={
                    props.requestMakeJudgementAddDocumentDecision
                  }
                  loaders={props.loaders}
                  currentJudiciaryProcess={props.currentJudiciaryProcess}
                  requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                  lossDate={get(props.claimRecap, 'claim.lossDate', null)}
                  setDocumentId={props.setDocumentId}
                  documentId={props.documentId}
                  isCivilProceeding={isCivilProceedingCommercial}
                  requestCreateMultipleJudgementAdd={
                    props.requestCreateMultipleJudgementAdd
                  }
                  expertReport={props.expertiseReport}
                  judgementOnMerits={props.appealOnMeritsMultiple}
                  requestAddSupportDocument={props.requestAddSupportDocument}
                  requestCivilPartySupportDocument={
                    props.requestCivilPartySupportDocument
                  }
                  sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisClaim, 'offeredRisks', []),
                  )}
                  setIsButtonRedirect={props.setIsButtonRedirect}
                  feeNotes={props.feeNotes}
                  setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                  isConsultation={true}
                  requestCreateIncomeCertificate={() => {}}
                  requestUpdateIncomeCertificate={() => {}}
                  requestMakeDecisionIncomeCertificate={() => {}}
                  imagineDocuments={[]}
                  requestGetClaimCivilParty={() => {}}
                  claimCivilParty={{}}
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
                <CourtManagerExpertReportAppeal
                  judgementAddDocuments={judgementAddDocuments}
                  listings={props.listings}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                  expertiseReport={props.expertiseReport}
                  requestValidateExpertReport={
                    props.requestValidateExpertReport
                  }
                  lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  documentId={props.documentId}
                  setDocumentId={props.setDocumentId}
                  claim={
                    (get(props.claimRecap, 'claim', {}) as unknown) as Claim
                  }
                  victims={filterVictim(get(props.claimRecap, 'victims', []))}
                  policyInfo={props.policyInfo}
                  judiciaryProcessId={props.judiciaryProcessId}
                  expertiseRaportFirstInstance={props.expertiseRaportAppeal}
                  requestGetExpertiseReportAppeal={
                    props.requestGetExpertiseReportAppeal
                  }
                  isManager
                  isAssignedLawyer={false}
                  isConsultation={true}
                  requestCreateExpertiseRaport={
                    props.requestCreateExpertiseRaport
                  }
                  requestAddExpertiseSupportDocument={
                    props.requestAddExpertiseSupportDocument
                  }
                  hasJom={!isEmpty(props.appealOnMeritsMultiple)}
                  sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisClaim, 'offeredRisks', []),
                  )}
                  imagineDocuments={[]}
                  dahirAmount={props.dahirAmount}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
                {ShowExpertExpertise(
                  props.expertExpertise,
                  props.judiciaryProcessId,
                  2,
                ) && (
                  <ExpertReport
                    expertisesVictim={
                      !isEmpty(props.expertExpertise) &&
                      props.expertExpertise.filter(
                        (el: any) =>
                          el?.mission?.judiciaryProcessId ===
                            props.judiciaryProcessId && el?.mission?.step === 2,
                      )
                    }
                    requestMakeDecisionMissionExpertise={
                      props.requestMakeDecisionMissionExpertise
                    }
                    claimId={props.match.params.claimId}
                    isLawyer={true}
                    feeNotes={props.feeNotes}
                    claimNumber={claimNumber}
                    riskKey={get(
                      get(props.sagisClaim, 'offeredRisks', []).find(
                        (element: { riskName: string }) =>
                          element.riskName === rcCoporeal,
                      ),
                      'riskId',
                    )}
                    setOpenFeeNoteDialog={() => {}}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}

                {!isEmpty(props.judgementOnMerits) && (
                  <JudgementOnMeritsManagerRecapAppeal
                    listings={props.listings}
                    claimId={claimId}
                    claimNumber={claimNumber}
                    expertiseReport={props.expertiseReport}
                    victims={get(props.claimRecap, 'victims', [])}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    civilProceeding={props.civilProceeding}
                    documentId={props.documentId}
                    requestValidateJudgementOnMerits={
                      props.requestValidateJudgementOnMerits
                    }
                    judgementAdd={props.judgementAdd}
                    judgementAddAppeal={props.judgementAddAppeal}
                    requestGetJudgementAddAppeal={
                      props.requestGetJudgementAddAppeal
                    }
                    lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                    setDocumentId={props.setDocumentId}
                    requestGetJudgementOnMerits={
                      props.requestGetJudgementOnMerits
                    }
                    judgementOnMerits={props.judgementOnMerits}
                    judgementAddDocuments={get(
                      judgementAddClone,
                      'judgementAddDocuments',
                      [],
                    )}
                    dahirAmount={props.dahirAmount}
                    policyInfo={props.policyInfo}
                    judgementAddClone={judgementAddClone}
                    claim={get(props.claimRecap, 'claim', [])}
                    judiciaryProcessId={props.judiciaryProcessId}
                    requestGetJudgementAdd={props.requestGetJudgementAdd}
                    requestGetExpertiseReport={props.requestGetExpertiseRaport}
                    requestCreateJudgementOnMeritsContestation={
                      props.requestCreateJudgementOnMeritsContestation
                    }
                    vehicules={filterVehicle(
                      get(props.claimRecap, 'vehicules', []),
                    )}
                    requestGetJudgementOnMeritsAppeal={
                      props.requestGetJudgementOnMeritsAppeal
                    }
                    judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                    expertiseRaportAppeal={props.expertiseRaportAppeal}
                    requestGetExpertiseReportAppeal={
                      props.requestGetExpertiseReportAppeal
                    }
                    isCivilProceeding={isCivilProceedingCommercial}
                    isManager
                    jomDeceasedVictims={getJomDeceasedVictimsAppeal(
                      judgementAddClone,
                      get(props.judgementOnMerits, 'judgementOnMerits.jom.id'),
                    )}
                    currentJudiciaryProcess={props.currentJudiciaryProcess}
                    isFirst={!isEmpty(props.judgementOnMerits)}
                    isAssignedLawyer={false}
                    requestAddJudgementOnMeritsSupportDocument={
                      props.requestAddJudgementOnMeritsSupportDocument
                    }
                    sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                    sagisOpposingParties={extractOpposingParties(
                      get(props.sagisClaim, 'offeredRisks', []),
                    )}
                    requestGetDahirAmount={props.requestGetDahirAmount}
                    setIsButtonRedirect={props.setIsButtonRedirect}
                    setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                    isConsultation={true}
                    imagineDocuments={[]}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}
                {appealOnMeritsMultiple
                  .sort(
                    (a: any, b: any) =>
                      new Date(get(a, 'createdAt')).valueOf() -
                      new Date(get(b, 'createdAt')).valueOf(),
                  )
                  .map((el: any) => (
                    <JudgementOnMeritsManagerRecapAppeal
                      listings={props.listings}
                      claimId={claimId}
                      claimNumber={claimNumber}
                      expertiseReport={props.expertiseReport}
                      victims={get(props.claimRecap, 'victims', [])}
                      uploadDocument={props.uploadDocument}
                      uploadedDocument={props.uploadedDocument}
                      resetUploadedDocument={props.resetUploadedDocument}
                      civilProceeding={props.civilProceeding}
                      documentId={props.documentId}
                      requestValidateJudgementOnMerits={
                        props.requestValidateJudgementOnMerits
                      }
                      judgementAdd={props.judgementAdd}
                      judgementAddAppeal={props.judgementAddAppeal}
                      requestGetJudgementAddAppeal={
                        props.requestGetJudgementAddAppeal
                      }
                      lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
                      setDocumentId={props.setDocumentId}
                      requestGetJudgementOnMerits={
                        props.requestGetJudgementOnMerits
                      }
                      judgementOnMerits={
                        {
                          judgementOnMerits: { ...el },
                          beneficiaries: [
                            ...get(
                              props.appealOnMeritsMultiple,
                              'beneficiaries',
                              [],
                            ),
                          ],
                        } as any
                      }
                      judgementAddDocuments={get(
                        judgementAddClone,
                        'judgementAddDocuments',
                        [],
                      )}
                      dahirAmount={props.dahirAmount}
                      policyInfo={props.policyInfo}
                      judgementAddClone={judgementAddClone}
                      claim={get(props.claimRecap, 'claim', [])}
                      judiciaryProcessId={props.judiciaryProcessId}
                      requestGetJudgementAdd={props.requestGetJudgementAdd}
                      requestGetExpertiseReport={
                        props.requestGetExpertiseRaport
                      }
                      requestCreateJudgementOnMeritsContestation={
                        props.requestCreateJudgementOnMeritsContestation
                      }
                      vehicules={filterVehicle(
                        get(props.claimRecap, 'vehicules', []),
                      )}
                      requestGetJudgementOnMeritsAppeal={
                        props.requestGetJudgementOnMeritsAppeal
                      }
                      judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                      expertiseRaportAppeal={props.expertiseRaportAppeal}
                      requestGetExpertiseReportAppeal={
                        props.requestGetExpertiseReportAppeal
                      }
                      isCivilProceeding={isCivilProceedingCommercial}
                      isManager
                      isMultiple
                      jomDeceasedVictims={getJomDeceasedVictimsAppeal(
                        judgementAddClone,
                        get(el, 'jom.id'),
                      )}
                      isAssignedLawyer={false}
                      requestAddJudgementOnMeritsSupportDocument={
                        props.requestAddJudgementOnMeritsSupportDocument
                      }
                      sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                      sagisOpposingParties={extractOpposingParties(
                        get(props.sagisClaim, 'offeredRisks', []),
                      )}
                      requestGetDahirAmount={props.requestGetDahirAmount}
                      setIsButtonRedirect={props.setIsButtonRedirect}
                      setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                      isConsultation={true}
                      imagineDocuments={[]}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  ))}
              </ToggleTabs>
            </StyledSahamAppelTabs>

            {featureService.hasFeature(
              FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION,
            ) &&
              !isEmpty(
                get(props.judgementOnMerits, 'judgementOnMerits.jom.jmc', {}),
              ) && (
                <Contestation
                  listings={props.listings}
                  judgementOnMerits={
                    props.judgementOnMerits['judgementOnMerits']
                  }
                  contestationOwners={
                    props.listings.judgementOnMeritsContestationOwners
                  }
                  uploadDocument={props.uploadDocument}
                  documentId={props.documentId}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  uploadedDocument={props.uploadedDocument}
                  setDocumentId={props.setDocumentId}
                  lossDate={get(props.sagisClaim, 'lossDate', '')}
                  claim={props.claimRecap}
                  claimId={claimId}
                  updateContestation={props.updateContestation}
                  validator={currentUserStorage.get().username}
                  requestUploadContestationDocument={
                    props.requestUploadContestationDocument
                  }
                  claimNumber={claimNumber}
                  isCivilProceeding={isCivilProceedingCommercial}
                  isAssignedLawyer={false}
                  sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
                  isConsultation={true}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              )}
          </LegalProceedingTabs>
        ) : (
          <SahamTabs currentTabIndex={0} labels={labelsToDisplay}>
            <ClaimRecap
              listings={props.listings}
              storedClaimToPreopen={props.storedClaimToPreopen}
              requestClaimRecap={props.requestClaimRecap}
              claimRecap={props.claimRecap}
              policyInfo={props.policyInfo}
              requestSearchClaims={props.requestSearchClaims}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              claimId={claimId}
              shouldDisplayBreadCrumbs={false}
              className="recap-bloc"
              shouldNotGetClaim
              stakeholders={stakeholders}
              requestUpdateVictimInfo={props.requestUpdateVictimInfo}
              requestUpdateBeneficiaryInfo={props.requestUpdateBeneficiaryInfo}
              requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
              setClaimRecap={props.setClaimRecap}
              requestCreateVehicle={props.requestCreateVehicle}
              requestCreateVictim={props.requestAddVictims}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              sagisInfo={props.sagisClaim}
              keycloakToken={props.keyclokToken}
              requestGetReportsPolicy={props.requestGetReportsPolicy}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />

            <CourtManagerRecapAdd
              listings={props.listings}
              judgementAdd={props.judgementAdd}
              claimId={claimId}
              claimNumber={claimNumber}
              requestMakeJudgementAddDecision={
                props.requestMakeJudgementAddDecision
              }
              victims={filterVictim(get(props.claimRecap, 'victims', []))}
              vehicules={filterVehicle(get(props.claimRecap, 'vehicules', []))}
              policyInfo={props.policyInfo}
              claim={get(props.claimRecap, 'claim', {})}
              isCivilProceeding={isCivilProceeding}
              stakeholders={stakeholders}
              assignedLawyer={get(
                props.claimRecap,
                'claim.assignment[0].assignedLawyer',
              )}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              judiciaryProcessId={props.judiciaryProcessId}
              isManager
              requestMakeJudgementAddDocumentDecision={
                props.requestMakeJudgementAddDocumentDecision
              }
              loaders={props.loaders}
              sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
              sagisOpposingParties={extractOpposingParties(
                get(props.sagisClaim, 'offeredRisks', []),
              )}
              isConsultation
              requestGetDahirAmount={props.requestGetDahirAmount}
              requestGetClaimCivilParty={() => {}}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
            <CourtManagerExpertReport
              judgementAddDocuments={judgementAddDocuments}
              listings={props.listings}
              claimId={claimId}
              claimNumber={claimNumber}
              requestGetExpertiseRaport={props.requestGetExpertiseRaport}
              expertiseReport={props.expertiseReport}
              requestValidateExpertReport={props.requestValidateExpertReport}
              lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              policyInfo={props.policyInfo}
              resetUploadedDocument={props.resetUploadedDocument}
              claim={(get(props.claimRecap, 'claim', {}) as unknown) as Claim}
              victims={filterVictim(get(props.claimRecap, 'victims', []))}
              judiciaryProcessId={props.judiciaryProcessId}
              isManager
              requestCreateExpertiseRaport={props.requestCreateExpertiseRaport}
              currentIndexTabManager={props.currentIndexTabManager}
              requestAddExpertiseSupportDocument={
                props.requestAddExpertiseSupportDocument
              }
              sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
              sagisOpposingParties={extractOpposingParties(
                get(props.sagisClaim, 'offeredRisks', []),
              )}
              isConsultation
              imagineDocuments={[]}
              dahirAmount={props.dahirAmount}
              expertiseRaportFirstInstance={props.expertiseRaportAppeal}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
            <JudgementOnMeritsManagerRecap
              listings={props.listings}
              claimId={claimId}
              expertiseReport={props.expertiseReport}
              victims={filterVictim(get(props.claimRecap, 'victims', []))}
              claimNumber={claimNumber}
              uploadDocument={props.uploadDocument}
              civilProceeding={props.civilProceeding}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              documentId={props.documentId}
              requestValidateJudgementOnMerits={
                props.requestValidateJudgementOnMerits
              }
              judgementAdd={props.judgementAdd}
              lawyer={get(props.judgementAdd, JUDGEMENT.CREATOR)}
              setDocumentId={props.setDocumentId}
              requestGetJudgementOnMerits={props.requestGetJudgementOnMerits}
              judgementOnMerits={props.judgementOnMerits}
              judgementAddDocuments={get(
                judgementAddClone,
                'judgementAddDocuments',
                [],
              )}
              judgementAddClone={judgementAddClone}
              dahirAmount={props.dahirAmount}
              policyInfo={props.policyInfo}
              claim={get(props.claimRecap, 'claim', [])}
              judiciaryProcessId={props.judiciaryProcessId}
              dahirAmountsCorpo={props.dahirAmountsCorpo}
              requestCreateJudgementOnMeritsContestation={
                props.requestCreateJudgementOnMeritsContestation
              }
              isManager
              vehicules={filterVehicle(get(props.claimRecap, 'vehicules', []))}
              isCivilProceeding={isCivilProceedingCommercial}
              isAssignedLawyer={false}
              requestAddJudgementOnMeritsSupportDocument={
                props.requestAddJudgementOnMeritsSupportDocument
              }
              sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
              sagisOpposingParties={extractOpposingParties(
                get(props.sagisClaim, 'offeredRisks', []),
              )}
              currentIndexTabManager={props.currentIndexTabManager}
              judgementAddAppeal={props.judgementAddAppeal}
              requestGetDahirAmount={props.requestGetDahirAmount}
              currentInstanceTabIndexManager={
                props.currentInstanceTabIndexManager
              }
              currentGlobalTabManagerIndex={props.currentGlobalTabManagerIndex}
              currentJudiciaryProccessId={props.currentJudiciaryProccessId}
              setIsButtonRedirect={props.setIsButtonRedirect}
              setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
              isConsultation
              imagineDocuments={[]}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          </SahamTabs>
        )}
      </StyledSahamTabs>
      {showAlertInformation && (
        <AlertInformationDialog
          open={showAlertInformation}
          setShowAlertInformation={setShowAlertInformation}
          targetLocation={''}
          history={history}
        />
      )}
    </Container>
  );
};

export default injectIntl(ManagerLegalProceedingsPage);
